import s from './product-assistance.module.css';
import cn from 'clsx';
import { Icon } from 'mmds';

const RatingDisplay = ({ value, maxRating = 5 }) => {
    const ratingPoints = Array.from({ length: maxRating }, (_, i) => i < value);

    return (
        <div className={s.ratingDisplay}>
            {ratingPoints.map((filled, index) => (
                <div
                    key={index}
                    className={cn(
                        filled ? s.ratingFilled : s.ratingUnfilled,
                        s.ratingPoint
                    )}
                />
            ))}
        </div>
    );
};

const FitRatingDisplay = ({ value }) => {
    const gradientPosition = value * 10;

    const gradientStyle = {
        background: `linear-gradient(270deg, #D9D9D9 0%, #222 ${gradientPosition}%, rgba(217, 217, 217, 0.00) 100%)`,
        height: '4px',
        width: '10.25rem',
    };

    return <div style={gradientStyle} />;
};

const ProductRatings = ({ product, reviews }) => {
    return (
        <>
            <div className={s.stack} data-flow-space="small">
                <h2 className="mmds-copy-one">{product.title}</h2>
                <hr className="divider" data-color="steel" />
            </div>
            <div className={s.grid}>
                <div className={cn(s.card, s.stack)}>
                    <div className={s.average}>
                        <h3 className="mmds-title-four">{reviews.average}</h3>
                        <Icon icon="star" />
                    </div>
                    <p className="mmds-copy-three">{product.title}</p>
                </div>
                {reviews && reviews.percentageRecommended && (
                    <div className={cn(s.card, s.stack, s.spanTwo)}>
                        <h3 className="mmds-title-four">
                            {reviews.percentageRecommended}%
                        </h3>
                        <p className="mmds-copy-three">
                            of reviewers recommend this product
                        </p>
                    </div>
                )}
            </div>
            <hr className="divider" data-color="steel" />
            <div className={s.grid}>
                {reviews.averageProductRatings &&
                    Object.entries(reviews.averageProductRatings).map(
                        ([key, rating]: any) => (
                            <div
                                key={key}
                                className={cn(s.rating, s.stack)}
                                data-flow-space="medium"
                            >
                                <div className="mmds-copy-three">
                                    {rating.label}
                                </div>
                                {key === 'fit' ? (
                                    <FitRatingDisplay value={rating.value} />
                                ) : (
                                    <RatingDisplay value={rating.value} />
                                )}
                            </div>
                        )
                    )}
            </div>
        </>
    );
};

export default ProductRatings;
